/**
 * Centralized dirty-tracking suppression.
 *
 * A store subscription marks `ui.isDirty` whenever `graphData` changes, so any
 * edit to operations / materials / edges / groups enables Save — regardless of
 * which action or code path made the change. Load-time mutations (hydrate /
 * seed / reset) must NOT mark the freshly-loaded graph dirty, so they run
 * inside `runWithoutDirtyTracking`.
 */
let suppressed = false;

export function runWithoutDirtyTracking<T>(fn: () => T): T {
  const prev = suppressed;
  suppressed = true;
  try {
    return fn();
  } finally {
    suppressed = prev;
  }
}

export function isDirtyTrackingSuppressed(): boolean {
  return suppressed;
}
